import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

export const Button = styled.button`
  color: var(--nb-primary);
  text-decoration: underline;
  font-size: 12px;
  font-weight: 700;

  &:hover {
    font-weight: 700;
    color: #745ef6;
  }

  &:focus {
    border: 1px solid var(--nb-primary);
    border-radius: 0.4rem;
  }

  &:active {
    border: none;
    opacity: 1;
  }
`;
